import { isUndefinedOrEmpty } from '../../utils/strings';
import { AppRecord } from '../types';

interface Params {
  package_name?: string;
  apps: AppRecord[];
}

const findAppByPackageName = ({
  package_name,
  apps,
}: Params): AppRecord | undefined => {
  if (isUndefinedOrEmpty(package_name)) return;

  return apps.find((app) => app.package_name === package_name);
};

export default findAppByPackageName;
